import { useState } from "react";
import { Plus } from "lucide-react";

export function MealTagForm({ onAdd, existingTags }) {
  const [value, setValue] = useState("");
  const [submitting, setSubmitting] = useState(false);

  const trimmedValue = value.trim();
  const isDuplicate = existingTags?.some(
    (tag) => tag.tagContent.toLowerCase() === trimmedValue.toLowerCase(),
  );

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!trimmedValue || isDuplicate || submitting) {
      return;
    }

    setSubmitting(true);
    await onAdd(trimmedValue);
    setSubmitting(false);
    setValue("");
  };

  return (
    <form onSubmit={handleSubmit} className="mb-2">
      <div className="flex gap-2">
        <input
          type="text"
          value={value}
          onChange={(e) => setValue(e.target.value)}
          placeholder="e.g. Quick & Easy"
          maxLength={30}
          className="flex-1 px-3.5 py-2.5 text-sm border border-gray-200 rounded-lg focus:outline-none focus:ring-2 focus:ring-indigo-500/30 focus:border-indigo-500 transition-all"
        />
        <button
          type="submit"
          disabled={!trimmedValue || isDuplicate || submitting}
          className="flex items-center gap-1.5 px-4 py-2.5 text-sm font-medium text-white bg-black rounded-lg hover:opacity-90 transition-all disabled:opacity-40 disabled:cursor-not-allowed shrink-0"
        >
          <Plus size={16} />
          Add Tag
        </button>
      </div>
      {isDuplicate && (
        <p className="text-xs text-red-500 mt-1.5">
          You already have a tag with this name.
        </p>
      )}
    </form>
  );
}
